import './main.sass'
import {
  Progress,
  Collapse,
  ModalGallery,
  Gallery,
  PageController,
  Skills,
  MiniMap
} from '@components'
import type { ComponentFactory } from '@shared/types'

const services = {
  modalGallery: new ModalGallery(
    document.querySelector<HTMLDialogElement>('#modal-gallery')!
  ),
  pageController: new PageController()
}

const components: Record<string, ComponentFactory> = {
  '.progress-list': element => new Progress(element),
  'details.collapse': element => new Collapse(element as HTMLDetailsElement),
  'ul.gallery': element => new Gallery(element, services.modalGallery),
  '#spaceclub': element => new MiniMap(element),
  'section.skills': element => new Skills(element)
}

Object.entries(components).forEach(([selector, create]) => {
  document.querySelectorAll<HTMLElement>(selector).forEach(create)
})
